// Sets window.$/jQuery/Popper/NProgress from the real packages. Served as a
// non-deferred <head> script (see vite.vendor.config.mts) so these globals exist
// before the inline `$(...)` blocks in views run. The app bundle reuses this one
// instance via the window-shims.
import jQuery from "jquery";
import Popper from "popper.js";
import NProgress from "nprogress";

window.$ = window.jQuery = jQuery;
window.Popper = Popper;
window.NProgress = NProgress;
